/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSignupRef,
  UnifiedClassSignupRefOptional,
  UnifiedClassSignupRefMetaI,
  UnifiedClassSignupRefTrackedI,
} from "./unified-class-signup-ref";
import {
  UnifiedClassSignupRefTracked,
  UnifiedClassSignupRefMeta,
} from "./unified-class-signup-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassWlResultFull,
  UnifiedClassWlResultFullOptional,
  UnifiedClassWlResultFullMetaI,
  UnifiedClassWlResultFullTrackedI,
} from "./unified-class-wl-result-full";
import {
  UnifiedClassWlResultFullTracked,
  UnifiedClassWlResultFullMeta,
} from "./unified-class-wl-result-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WlResultTypeEnum,
  WlResultTypeEnumOptional,
  WlResultTypeEnumMetaI,
  WlResultTypeEnumTrackedI,
} from "./wl-result-type-enum";
import {
  WlResultTypeEnumTracked,
  WlResultTypeEnumMeta,
} from "./wl-result-type-enum";

/**
 *
 * @export
 * @interface WlResultDTO
 */
export interface WlResultDTOOptional extends UnifiedClassWlResultFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof WlResultDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WlResultDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {UnifiedClassSignupRef}
   * @memberof WlResultDTO
   */
  assignId?: UnifiedClassSignupRefOptional;
  /**
   *
   * @type {string}
   * @memberof WlResultDTO
   */
  foVmDatetime?: Date;
  /**
   *
   * @type {WlResultTypeEnum}
   * @memberof WlResultDTO
   */
  wlResult?: WlResultTypeEnum;
  /**
   *
   * @type {string}
   * @memberof WlResultDTO
   */
  offerExpDatetime?: Date;
  /**
   *
   * @type {string}
   * @memberof WlResultDTO
   */
  foAlertDatetime?: Date;
  /**
   *
   * @type {boolean}
   * @memberof WlResultDTO
   */
  permitOvercrowd?: boolean;
}

export interface WlResultDTO
  extends WlResultDTOOptional, UnifiedClassWlResultFull {
  /**
   *
   * @type {boolean}
   * @memberof WlResultDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WlResultDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {UnifiedClassSignupRef}
   * @memberof WlResultDTO
   */
  assignId: UnifiedClassSignupRef;
  /**
   *
   * @type {string}
   * @memberof WlResultDTO
   */
  foVmDatetime?: Date;
  /**
   *
   * @type {WlResultTypeEnum}
   * @memberof WlResultDTO
   */
  wlResult?: WlResultTypeEnum;
  /**
   *
   * @type {string}
   * @memberof WlResultDTO
   */
  offerExpDatetime?: Date;
  /**
   *
   * @type {string}
   * @memberof WlResultDTO
   */
  foAlertDatetime?: Date;
  /**
   *
   * @type {boolean}
   * @memberof WlResultDTO
   */
  permitOvercrowd?: boolean;
}

export interface WlResultDTOTrackedI extends UnifiedClassWlResultFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof WlResultDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WlResultDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {UnifiedClassSignupRef}
   * @memberof WlResultDTO
   */
  assignId?: UnifiedClassSignupRefTrackedI;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof WlResultDTO
   */
  foVmDatetime?: Date;
  foVmDatetimeIsSet: boolean;
  /**
   *
   * @type {WlResultTypeEnum}
   * @memberof WlResultDTO
   */
  wlResult?: WlResultTypeEnum;
  wlResultIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof WlResultDTO
   */
  offerExpDatetime?: Date;
  offerExpDatetimeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof WlResultDTO
   */
  foAlertDatetime?: Date;
  foAlertDatetimeIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WlResultDTO
   */
  permitOvercrowd?: boolean;
  permitOvercrowdIsSet: boolean;
}

transformDatesMap.set("WlResultDTO", function (model: WlResultDTO) {
  const transformDatesassignId = transformDatesMap.get("UnifiedClassSignupRef");
  if (transformDatesassignId && model.assignId) {
    transformDatesassignId(model.assignId);
  }
  if (typeof model.foVmDatetime == "string")
    model.foVmDatetime = new Date(model.foVmDatetime);
  if (typeof model.offerExpDatetime == "string")
    model.offerExpDatetime = new Date(model.offerExpDatetime);
  if (typeof model.foAlertDatetime == "string")
    model.foAlertDatetime = new Date(model.foAlertDatetime);
});

export type WlResultDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<UnifiedClassSignupRefMetaI>;
  //isDate: false
  //isDatetime: true
  foVmDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  wlResult: PropertyMeta<WlResultTypeEnumMetaI>;
  //isDate: false
  //isDatetime: true
  offerExpDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  foAlertDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  permitOvercrowd: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var WlResultDTOMeta: WlResultDTOMetaI = {} as WlResultDTOMetaI;
WlResultDTOMeta = typeMeta("WlResultDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta(
    "assignId",
    false,
    true,
    true,
    UnifiedClassSignupRefMeta,
  ),
  foVmDatetime: propertyMeta(
    "foVmDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  wlResult: propertyMeta("wlResult", false, false, false, WlResultTypeEnumMeta),
  offerExpDatetime: propertyMeta(
    "offerExpDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  foAlertDatetime: propertyMeta(
    "foAlertDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  permitOvercrowd: propertyMeta(
    "permitOvercrowd",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = WlResultDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassWlResultFullMeta]);
  metaI.isDeleted.inheritedFrom = UnifiedClassWlResultFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = UnifiedClassWlResultFullMeta.isNew;
  metaI.assignId.inheritedFrom = UnifiedClassWlResultFullMeta.assignId;
  metaI.foVmDatetime.inheritedFrom = UnifiedClassWlResultFullMeta.foVmDatetime;
  metaI.wlResult.inheritedFrom = UnifiedClassWlResultFullMeta.wlResult;
  metaI.offerExpDatetime.inheritedFrom =
    UnifiedClassWlResultFullMeta.offerExpDatetime;
  metaI.foAlertDatetime.inheritedFrom =
    UnifiedClassWlResultFullMeta.foAlertDatetime;
  metaI.permitOvercrowd.inheritedFrom =
    UnifiedClassWlResultFullMeta.permitOvercrowd;
});

export class WlResultDTOTracked
  extends UnifiedClassWlResultFullTracked
  implements WlResultDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: UnifiedClassSignupRefTracked = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | UnifiedClassSignupRefTracked) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  foVmDatetime__I?: Date = undefined;
  foVmDatetimeIsSet: boolean = false;
  set foVmDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.foVmDatetime__I = v;
      this.foVmDatetimeIsSet = true;
    } else {
      this.foVmDatetime__I = v || undefined;
      this.foVmDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get foVmDatetime() {
    return this.foVmDatetime__I;
  }
  wlResult__I?: WlResultTypeEnum = undefined;
  wlResultIsSet: boolean = false;
  set wlResult(v: undefined | WlResultTypeEnum) {
    if (v !== undefined) {
      this.wlResult__I = v;
      this.wlResultIsSet = true;
    } else {
      this.wlResult__I = v || undefined;
      this.wlResultIsSet = false;
    }
    this.changeTracker = true;
  }
  get wlResult() {
    return this.wlResult__I;
  }
  offerExpDatetime__I?: Date = undefined;
  offerExpDatetimeIsSet: boolean = false;
  set offerExpDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.offerExpDatetime__I = v;
      this.offerExpDatetimeIsSet = true;
    } else {
      this.offerExpDatetime__I = v || undefined;
      this.offerExpDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get offerExpDatetime() {
    return this.offerExpDatetime__I;
  }
  foAlertDatetime__I?: Date = undefined;
  foAlertDatetimeIsSet: boolean = false;
  set foAlertDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.foAlertDatetime__I = v;
      this.foAlertDatetimeIsSet = true;
    } else {
      this.foAlertDatetime__I = v || undefined;
      this.foAlertDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get foAlertDatetime() {
    return this.foAlertDatetime__I;
  }
  permitOvercrowd__I?: boolean = undefined;
  permitOvercrowdIsSet: boolean = false;
  set permitOvercrowd(v: undefined | boolean) {
    if (v !== undefined) {
      this.permitOvercrowd__I = v;
      this.permitOvercrowdIsSet = true;
    } else {
      this.permitOvercrowd__I = v || undefined;
      this.permitOvercrowdIsSet = false;
    }
    this.changeTracker = true;
  }
  get permitOvercrowd() {
    return this.permitOvercrowd__I;
  }
  constructor(config?: WlResultDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
    this.assignId?.setIds();
  }
  assignFrom(
    config: WlResultDTOOptional,
    options?: AssignOptions,
  ): WlResultDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = new UnifiedClassSignupRefTracked(
        config.assignId,
        options,
      );
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.foVmDatetime &&
      this.foVmDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.foVmDatetime = config.foVmDatetime;
      if (optionsRequired.unassign) this.foVmDatetimeIsSet = false;
      else this.foVmDatetimeIsSet = true;
    }
    if (config.wlResult && this.wlResultApplyFilter(optionsRequired.filter)) {
      this.wlResult = config.wlResult;
      if (optionsRequired.unassign) this.wlResultIsSet = false;
      else this.wlResultIsSet = true;
    }
    if (
      config.offerExpDatetime &&
      this.offerExpDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.offerExpDatetime = config.offerExpDatetime;
      if (optionsRequired.unassign) this.offerExpDatetimeIsSet = false;
      else this.offerExpDatetimeIsSet = true;
    }
    if (
      config.foAlertDatetime &&
      this.foAlertDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.foAlertDatetime = config.foAlertDatetime;
      if (optionsRequired.unassign) this.foAlertDatetimeIsSet = false;
      else this.foAlertDatetimeIsSet = true;
    }
    if (
      config.permitOvercrowd &&
      this.permitOvercrowdApplyFilter(optionsRequired.filter)
    ) {
      this.permitOvercrowd = config.permitOvercrowd;
      if (optionsRequired.unassign) this.permitOvercrowdIsSet = false;
      else this.permitOvercrowdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WlResultDTOTrackedI {
    const cloned = {} as WlResultDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId?.removeUnset(filter);
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.foVmDatetimeIsSetDeep() &&
      this.foVmDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.foVmDatetimeIsSet = true;
      cloned.foVmDatetime = this.foVmDatetime;
    } else {
      //cloned.foVmDatetimeIsSet = false
    }
    if (
      this.wlResultIsSetDeep() &&
      this.wlResultApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.wlResultIsSet = true;
      cloned.wlResult = this.wlResult;
    } else {
      //cloned.wlResultIsSet = false
    }
    if (
      this.offerExpDatetimeIsSetDeep() &&
      this.offerExpDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.offerExpDatetimeIsSet = true;
      cloned.offerExpDatetime = this.offerExpDatetime;
    } else {
      //cloned.offerExpDatetimeIsSet = false
    }
    if (
      this.foAlertDatetimeIsSetDeep() &&
      this.foAlertDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.foAlertDatetimeIsSet = true;
      cloned.foAlertDatetime = this.foAlertDatetime;
    } else {
      //cloned.foAlertDatetimeIsSet = false
    }
    if (
      this.permitOvercrowdIsSetDeep() &&
      this.permitOvercrowdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.permitOvercrowdIsSet = true;
      cloned.permitOvercrowd = this.permitOvercrowd;
    } else {
      //cloned.permitOvercrowdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WlResultDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;
    this.assignId?.unassignAll(filter);

    if (!this.foVmDatetimeApplyFilter(filter)) this.foVmDatetimeIsSet = false;

    if (!this.wlResultApplyFilter(filter)) this.wlResultIsSet = false;

    if (!this.offerExpDatetimeApplyFilter(filter))
      this.offerExpDatetimeIsSet = false;

    if (!this.foAlertDatetimeApplyFilter(filter))
      this.foAlertDatetimeIsSet = false;

    if (!this.permitOvercrowdApplyFilter(filter))
      this.permitOvercrowdIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WlResultDTOMeta.isDeleted,
      WlResultDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(WlResultDTOMeta.isNew, WlResultDTOMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WlResultDTOMeta.assignId,
      WlResultDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;
    return this.assignId?.anySet(filter) == true;

    return false;
  }
  foVmDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WlResultDTOMeta.foVmDatetime,
      WlResultDTOMeta,
      this.foVmDatetime,
      this,
    );
  }
  foVmDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.foVmDatetimeIsSet && this.foVmDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  wlResultApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WlResultDTOMeta.wlResult,
      WlResultDTOMeta,
      this.wlResult,
      this,
    );
  }
  wlResultIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.wlResultIsSet && this.wlResultApplyFilter(filter)) return true;

    return false;
  }
  offerExpDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WlResultDTOMeta.offerExpDatetime,
      WlResultDTOMeta,
      this.offerExpDatetime,
      this,
    );
  }
  offerExpDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.offerExpDatetimeIsSet && this.offerExpDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  foAlertDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WlResultDTOMeta.foAlertDatetime,
      WlResultDTOMeta,
      this.foAlertDatetime,
      this,
    );
  }
  foAlertDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.foAlertDatetimeIsSet && this.foAlertDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  permitOvercrowdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WlResultDTOMeta.permitOvercrowd,
      WlResultDTOMeta,
      this.permitOvercrowd,
      this,
    );
  }
  permitOvercrowdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.permitOvercrowdIsSet && this.permitOvercrowdApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.foVmDatetimeIsSetDeep(filter)) return true;
    if (this.wlResultIsSetDeep(filter)) return true;
    if (this.offerExpDatetimeIsSetDeep(filter)) return true;
    if (this.foAlertDatetimeIsSetDeep(filter)) return true;
    if (this.permitOvercrowdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
